
import { defineComponent } from "vue";

import FieldSearch from "~/vue/molecules/fields/FieldSearch.vue";
import ViewSearch from "~/vue/organisms/views/ViewSearch.vue";

import { Translations } from "~/js/interfaces/translations";
import { Category } from "~/js/interfaces/knowledge-hub";

export default defineComponent({
	components: {
		"field--search": FieldSearch,
		"view--search": ViewSearch,
	},
	props: {
		filterable: {
			type: Boolean,
			default: true,
		},
		industries: {
			type: Array as () => Category[],
			default: () => [],
		},
		paginated: {
			type: Boolean,
			default: true,
		},
		solutions: {
			type: Array as () => Category[],
			default: () => [],
		},
		translations: {
			type: Object as () => Translations | null,
			default: null,
		},
	},
});
